import React from "react";
import styled from "styled-components";
import api from "../../../../util/api";
import { toast } from "react-toastify";

const Overlay = styled.div`
    display: ${(p) => (p.open ? "flex" : "none")};
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.4); z-index: 1000;
    align-items: center; justify-content: center;
`;
const Modal = styled.div`
    background: white; width: 420px; max-width: 90%;
    padding: 24px; border-radius: 8px;
`;
const Heading = styled.h2`font-size: 22px; margin: 0 0 16px;`;
const Label = styled.label`display: block; font-weight: 600;`;
const Hint = styled.div`color: #737697; font-size: 12px; margin-top: 4px;`;
const CheckRow = styled.label`display: block; margin-top: 6px;`;
const Actions = styled.div`margin-top: 24px; display: flex; justify-content: flex-end; gap: 12px;`;
const Btn = styled.button`
    padding: 8px 16px; border: none; border-radius: 4px; cursor: pointer;
    background: ${(p) => (p.primary ? "#5562C0" : "#eee")};
    color: ${(p) => (p.primary ? "white" : "#333")};
`;

export default class StudentFileShareModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { selectedInstructorIds: [], submitting: false, file: null };
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open && this.props.fileId) {
            this.setState({ selectedInstructorIds: [], file: null });
            api().get(`/files/${this.props.fileId}`).then((res) => {
                const file = res.data.data;
                const ids = (file.shared_user_ids || []).map((x) => Number(x));
                this.setState({ file, selectedInstructorIds: ids });
            });
        }
    }

    toggleInstructor(id) {
        this.setState((prev) => {
            const has = prev.selectedInstructorIds.includes(id);
            return {
                selectedInstructorIds: has
                    ? prev.selectedInstructorIds.filter((x) => x !== id)
                    : [...prev.selectedInstructorIds, id],
            };
        });
    }

    submit() {
        const { fileId } = this.props;
        const payload = {
            name: this.state.file?.name,
            extra_user_ids: this.state.selectedInstructorIds.map((id) => ({ value: id })),
        };
        this.setState({ submitting: true });
        api().put(`/files/${fileId}`, payload)
            .then(() => {
                toast.success("Sharing updated.", { position: "top-right", autoClose: 5000, hideProgressBar: true });
                this.setState({ submitting: false });
                this.props.onSaved && this.props.onSaved();
                this.props.onClose();
            })
            .catch(() => {
                this.setState({ submitting: false });
                toast.error("Couldn't update sharing, please try again.", { position: "top-right", autoClose: 5000 });
            });
    }

    render() {
        const { open, onClose, instructors = [] } = this.props;
        const { file, selectedInstructorIds, submitting } = this.state;

        return (
            <Overlay open={open} onClick={onClose}>
                <Modal onClick={(e) => e.stopPropagation()}>
                    <Heading>Share {file ? `"${file.name}"` : "File"}</Heading>

                    <Label>Share with</Label>
                    {instructors.length === 0 ? (
                        <Hint>You'll be able to share files once you have an instructor.</Hint>
                    ) : (
                        instructors.map((inst) => (
                            <CheckRow key={inst.id}>
                                <input
                                    type="checkbox"
                                    checked={selectedInstructorIds.includes(inst.id)}
                                    onChange={() => this.toggleInstructor(inst.id)}
                                />
                                {" "}{inst.name}
                            </CheckRow>
                        ))
                    )}

                    <Actions>
                        <Btn onClick={onClose} disabled={submitting}>Cancel</Btn>
                        <Btn primary onClick={() => this.submit()} disabled={submitting || !file}>
                            {submitting ? "Saving…" : "Save"}
                        </Btn>
                    </Actions>
                </Modal>
            </Overlay>
        );
    }
}
